import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { protectedResources } from '../auth/auth.config';
import { CompanyRoleType, ProfileType } from '../models/user.model';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private http: HttpClient) {}
  apiEndpoint: string = protectedResources.apiTodoList.endpoint;

  getProfile() {
    return this.http.get<ProfileType>(`${this.apiEndpoint}/profile`);
  }

  editProfile(data: ProfileType) {
    return this.http.post<ProfileType>(`${this.apiEndpoint}/profile`, data);
  }

  changeProfileRole(
    memberId: string,
    companyId: string,
    role: Pick<CompanyRoleType, 'role'>,
  ) {
    return this.http.put<Pick<CompanyRoleType, 'role'>>(
      `${this.apiEndpoint}/companies/${companyId}/roles/${memberId}`,
      role,
    );
  }

  static isProfileComplete(data: ProfileType): boolean {
    return Boolean(data.firstName && data.lastName && data.jobTitle);
  }
}
